export const SETUP_WIZARD_FINISH = 'SETUP_WIZARD_FINISH'

export const SET_SETUP_WIZARD_SUCCESS = 'SET_SETUP_WIZARD_SUCCESS'
